import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { PackagingTypeColumns } from "../../../tableColumns/table-columns";
import { packagingTypeJson } from "../../../DynamicFormsJson/MastersJSON/PackagingType";
import { getPackagingType } from "../../../Slice/packagingType.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiDelete } from "../../../utils/api_service";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  serverMsg,
} from "../../../config/messageconstant";

class PackagingTypeList extends React.Component {
  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;

    if (rowData.id) {
      showLoador({ loador: true });
      apiDelete({
        url: endpoint.packagingType + "/" + rowData.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data && data.data.statusCode == 200) {
            showNotification({ msg: deletemsg });
            window.location.reload();
          } else {
            showNotification({ msg: deleteFailedMsg, severity: "error" });
          }
        } else {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
      });
    }
  };
  render() {
    const { packagingTypeList, getPackagingType } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={packagingTypeJson.formPath}
          screenTitle={packagingTypeJson.screenTitle}
          fieldMeta={packagingTypeJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={true}
          changeExcelURL={packagingTypeJson.excelUrl}
          showExtension={false}
          filterDataExcel={true}
          pdfFileName={packagingTypeJson.pdfFileName}
          excelFileName={packagingTypeJson.excelFileName}
          showAddButton={packagingTypeJson.showAddButton}
          tableColumnsToFilter={packagingTypeJson.tableColumnsToFilter}
          tableColumns={PackagingTypeColumns}
          tableData={packagingTypeList?.packagingType}
          getTableData={getPackagingType}
          apiBaseURL={packagingTypeJson.apiBaseURL}
          isNote={true}
          isNoteValue={"Types Of Packaging For Products"}
          showDeleteIcon={true}
          isLog={true}
          type={0}
          deleteURLStatic={true}
          onDeleteStatic={this.rowDelete}
          showViewButtonInTable={true}
          formPathView={packagingTypeJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  packagingTypeList: state.packagingType,
});
const mapDispatchToProps = {
  getPackagingType,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(PackagingTypeList);
